import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';
import { CastingFormatType } from 'src/app/components/att-casting-view/formats/casting-formats-sel/casting-formats-sel.component';

@Injectable({
	providedIn: 'root'
})
export class NumberPhoneQualifierService implements Qualifier {
	static supportedStats = ['count', 'first', 'last', 'max', 'median', 'min'];
	static FromString(value: string): number {
		if (!value) {
			value = '';
		}
		const matches = value.match(/(\d)/g);
		if (matches === null) {
			return 0;
		}
		let num = Number(matches.join(''));
		if (isNaN(num)) {
			num = 0;
		}
		return num;

	}
	static ToString(value: number, format: CastingTypeFormat): string {
		let matches: Array<string>;
		switch (format) {
			case 'phone-0cc334-dashed':
				matches = ('' + value).match(/(\d*)(\d{3})(\d{3})(\d{4})$/);
				if (matches === null) {
					return null;
				}
				if (matches[1] === '') {
					matches[1] = '1';
				}
				return ('' + matches[1]).padStart(3, '0') + '-' + matches[2] + '-' + matches[3] + '-' + matches[4];
			case 'phone-0cc334-spaced':
				matches = ('' + value).match(/(\d*)(\d{3})(\d{3})(\d{4})$/);
				if (matches === null) {
					return null;
				}
				if (matches[1] === '') {
					matches[1] = '1';
				}
				return ('' + matches[1]).padStart(3, '0') + ' ' + matches[2] + ' ' + matches[3] + ' ' + matches[4];
			case 'phone-334-dotted':
				matches = ('' + value).match(/(\d{3})(\d{3})(\d{4})$/);
				return ('' + matches[1] + '.' + matches[2] + '.' + matches[3]);
			case 'phone-cc334-dashed':
				matches = ('' + value).match(/(\d*)(\d{3})(\d{3})(\d{4})$/);
				if (matches[1] === '') {
					matches[1] = '1';
				}
				return (matches[1] + '-' + matches[2] + '-' + matches[3] + '-' + matches[4]);
			case 'phone-cc334-dotted':
				matches = ('' + value).match(/(\d*)(\d{3})(\d{3})(\d{4})$/);
				if (matches[1] === '') {
					matches[1] = '1';
				}
				return (matches[1] + '.' + matches[2] + '.' + matches[3] + '.' + matches[4]);
			case 'phone-p3-sp-3dash4':
				matches = ('' + value).match(/(\d{3})(\d{3})(\d{4})$/);
				return '(' + matches[1] + ') ' + matches[2] + '-' + matches[3];
			case 'phone-pcc334-dashed':
				matches = ('' + value).match(/(\d*)(\d{3})(\d{3})(\d{4})$/);
				if (matches[1] === '') {
					matches[1] = '1';
				}
				return '+' + matches[1] + '-' + matches[2] + '-' + matches[3] + '-' + matches[4];
			case 'phone-pccp3-34dashed':
				matches = ('' + value).match(/(\d*)(\d{3})(\d{3})(\d{4})$/);
				if (matches[1] === '') {
					matches[1] = '1';
				}
				return '+' + matches[1] + '(' + matches[2] + ')' + matches[3] + '-' + matches[4];
		}
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return NumberPhoneQualifierService.ToString(val, casting.format);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if ([undefined, null].indexOf(val) > -1) {
			return '';
		}
		return NumberPhoneQualifierService.GetDisplayValue(attribute, castingMode, val);
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		return NumberPhoneQualifierService.FromString(value);
	}
	public static SupportsStat(statName): boolean {
		return NumberPhoneQualifierService.supportedStats.indexOf(statName) > -1;
	}
	constructor() { }
	public static GetNumFormat(attribute: AttributeInfo, castingMode: CastingMode) {
		const format = attribute.casting[castingMode].format;

		switch (format) {
			case 'phone-0cc334-dashed':
				return '"0"0-000-000-0000';
			case 'phone-0cc334-spaced':
				return '"0"0 000 000 0000';
			case 'phone-334-dotted':
				return '000 000 0000';
			case 'phone-cc334-dashed':
				return '0-000-000-0000';
			case 'phone-cc334-dotted':
				return '0.000.000.0000';
			case 'phone-p3-sp-3dash4':
				return '(000) 000-0000';
			case 'phone-pcc334-dashed':
				return '+0-000-000-0000'
			case 'phone-pccp3-34dashed':
				return '+0(000)000-0000'
		}
	}
	public static GetMaxVal(format: CastingTypeFormat, val: number) {
		switch (format) {
			case 'phone-0cc334-dashed':
			case 'phone-0cc334-spaced':
			case 'phone-cc334-dashed':
			case 'phone-cc334-dotted':
			case 'phone-pcc334-dashed':
			case 'phone-pccp3-34dashed':
				return val;
			case 'phone-334-dotted':
			case 'phone-p3-sp-3dash4':
				const strVal = (''+val);
				if(strVal.length < 10) {
					return val;
				}
				return Number(strVal.substr(-10));
		}
	}
}
